import React from 'react';
import { Copy, ThumbsUp, ThumbsDown } from 'lucide-react';

interface MessageActionsProps {
  reaction: 'up' | 'down' | null;
  onCopy: () => void;
  onReaction: (type: 'up' | 'down') => void;
}

const MessageActions = React.memo(function MessageActions({
  reaction,
  onCopy,
  onReaction,
}: MessageActionsProps) {
  return (
    <div className="absolute -top-2 -right-2 flex gap-1 bg-white border rounded-lg shadow-sm p-1">
      <button
        onClick={onCopy}
        type="button"
        className="p-1 hover:bg-gray-100 rounded focus:outline-2 focus:outline-blue-500"
        title="Copy message"
        aria-label="Copy message"
      >
        <Copy className="w-3 h-3 text-gray-600" aria-hidden="true" />
      </button>
      <button
        onClick={() => onReaction('up')}
        type="button"
        className={`p-1 hover:bg-gray-100 rounded focus:outline-2 focus:outline-blue-500 ${reaction === 'up' ? 'bg-green-50' : ''}`}
        title="Good response"
        aria-label="Thumbs up"
        aria-pressed={reaction === 'up'}
      >
        <ThumbsUp
          className={`w-3 h-3 ${reaction === 'up' ? 'text-green-600' : 'text-gray-600'}`}
          aria-hidden="true"
        />
      </button>
      <button
        onClick={() => onReaction('down')}
        type="button"
        className={`p-1 hover:bg-gray-100 rounded focus:outline-2 focus:outline-blue-500 ${reaction === 'down' ? 'bg-red-50' : ''}`}
        title="Not helpful"
        aria-label="Thumbs down"
        aria-pressed={reaction === 'down'}
      >
        <ThumbsDown
          className={`w-3 h-3 ${reaction === 'down' ? 'text-red-600' : 'text-gray-600'}`}
          aria-hidden="true"
        />
      </button>
    </div>
  );
});

export default MessageActions;
